import { Controller } from "@hotwired/stimulus"

// 選考タスクの「対応済み」チェックに連動して対応日入力欄を表示するコントローラ。
// チェックON: 日付欄を表示し、空なら今日の日付を補完する。
// チェックOFF: 日付欄を隠して値をクリアする。
export default class extends Controller {
  static targets = ["checkbox", "dateField"]

  connect() {
    this.toggle()
  }

  toggle() {
    const checked = this.checkboxTarget.checked
    // 入力欄は <label>対応日 <input></label> で囲まれているため、
    // input 単体ではなく親ラベルごと出し入れする（「対応日」テキストの残留を防ぐ）。
    const wrapper = this.dateFieldTarget.closest("label") || this.dateFieldTarget
    wrapper.hidden = !checked
    if (checked && !this.dateFieldTarget.value) {
      this.dateFieldTarget.value = this.todayString()
    }
    if (!checked) {
      this.dateFieldTarget.value = ""
    }
  }

  // ローカルタイムの今日を "YYYY-MM-DD" で返す（date input 用）。
  todayString() {
    const now = new Date()
    const month = String(now.getMonth() + 1).padStart(2, "0")
    const day = String(now.getDate()).padStart(2, "0")
    return `${now.getFullYear()}-${month}-${day}`
  }
}
